module.exports = __webpack_public_path__ + "img/check.5551035e.svg";